/**
 * @fileoverview Agent definition for extract-world-elements-v3.
 *
 * Composite agent that orchestrates the full world element extraction pipeline:
 * parallel detection (core + rare) → merge/dedup → enrichment (detailer).
 *
 * @category world-building.extraction
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'extract-world-elements-v3',
  kind: 'composite',
  name: 'Extract World Elements',
  description: 'Extracts all world element types using parallel detection (surface + inferential) and enrichment.',
  category: 'world-building',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.extraction',
    usedBy: [
      'use-extract-world-elements-v3.ts',
    ],
    composedOf: [
      'world-element-core-detector-v3',
      'world-element-rare-detector-v3',
      'world-element-detailer-v3',
    ],
    relatedAgents: [
      'world-element-core-detector-v3',
      'world-element-rare-detector-v3',
      'world-element-detailer-v3',
    ],
  },
};
